import { useMemo } from 'react';

import { ActiveSpeechTags, TranscriptResponse } from '../lib/entities/speech-tags';

export const useSpeechTags = (data: TranscriptResponse | null | undefined): ActiveSpeechTags => {
	return useMemo(() => {
		if (!data) {
			return {
				mentions: false,
				points: false,
				hashtags: false,
				interstitial_mentions: false,
			};
		}

		return {
			mentions: data.matched_users.length > 0,
			points: !!data.speech_tags.points,
			hashtags: (data.speech_tags.hashtags?.length ?? 0) > 0,
			interstitial_mentions: (data.speech_tags.names?.length ?? 0) > 0 && data.matched_users.length === 0,
		};
	}, [data?.matched_users.length, data?.speech_tags.points, data?.speech_tags.hashtags?.length, data?.speech_tags.names?.length]);
};
